








import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseTooltip extends Vue {
  mounted() {
    this.position();
  }

  @Prop({ required: false, default: "" })
  fixPosition!: "left" | "right";

  positionClass = ""; // center tooltip by default

  // Position the tooltip so it never bleeds off the screen
  position() {
    if (this.fixPosition) {
      this.positionClass = this.fixPosition;
    } else {
      const tooltip: any = this.$refs.tooltip;
      const rect = tooltip.getBoundingClientRect();
      const space = 16; // corresponds to 1em/$space sass var

      // Add extra space so tooltip position switches before touching window boundary
      const limitRight = rect.x + rect.width + space;
      const limitLeft = rect.x - space;

      if (limitLeft < 0) {
        this.positionClass = "left";
      } else if (limitRight > window.innerWidth) {
        this.positionClass = "right";
      }
      // else do nothing, default center align
    }
  }
}
